<template>
    <section class="sidebarFilter">
        <p class="sidebarFilter__desc">
            {{ trans('EXTENDED_SEARCH_LANGUAGE_FILTER_DESC') }}
        </p>
        <div class="sidebarFilter__wrapperRadioButton">
            <label class="sidebarFilter__container">
                <input
                    :id="'allLanguages'"
                    :checked="allLanguages"
                    data-gtm="sidebarFilter__language--all"
                    type="radio"
                    class="sidebarFilter__input"
                    tabindex="0"
                    @keyup.enter="selectLanguage(all)"
                    @click="selectLanguage(all)" />
                <span class="sidebarFilter__radioButton"></span>
                {{ trans('EXTENDED_SEARCH_LANGUAGE_ALL') }}
            </label>
            <label class="sidebarFilter__container">
                <input
                    :id="'localeLanguage'"
                    :checked="localeLanguage"
                    data-gtm="sidebarFilter__language--localOnly"
                    class="sidebarFilter__input"
                    type="radio"
                    tabindex="0"
                    @keyup.enter="selectLanguage(locale)"
                    @click="selectLanguage(locale)" />
                <span class="sidebarFilter__radioButton"></span>
                {{ trans('EXTENDED_SEARCH_ONLY_LOCALE') }}
            </label>
            <label class="sidebarFilter__container">
                <input
                    :id="'englishLanguage'"
                    :checked="englishLanguage"
                    data-gtm="sidebarFilter__language--englishOnly"
                    class="sidebarFilter__input"
                    type="radio"
                    tabindex="0"
                    @keyup.enter="selectLanguage(english)"
                    @click="selectLanguage(english)" />
                <span class="sidebarFilter__radioButton"></span>
                {{ trans('EXTENDED_SEARCH_ONLY_ENGLISH') }}
            </label>
        </div>
    </section>
</template>

<script>
    import Translator from 'tools/trans';
    import { useGetters } from 'composables/useVuex';
    export default {
        name: 'LanguageFilter',
        data() {
            return {
                all: this.trans('EXTENDED_SEARCH_LANGUAGE_ALL'),
                locale: this.trans('EXTENDED_SEARCH_ONLY_LOCALE'),
                english: this.trans('EXTENDED_SEARCH_ONLY_ENGLISH'),
                allLanguages: false,
                localeLanguage: false,
                englishLanguage: false,
                languageIdForLocal: {
                    'de': '1',
                    'fr': '3',
                    'es': '4',
                },
            };
        },
        methods: {
            trans: Translator.trans,
            selectLanguage(value) {
                if (value === this.locale) {
                    this.localeLanguage = true;
                    this.allLanguages = false;
                    this.englishLanguage = false;
                    const valueForLocal = this.languageIdForLocal[window.stGlobals.locale];
                    this.$emit('selected-language-name', this.locale);
                    this.$parent.$emit('selected-language', valueForLocal); // TODO - persisting this in some store and in subcomponent and react to the change
                } else if (value === this.english) {
                    this.englishLanguage = true;
                    this.localeLanguage = false;
                    this.allLanguages = false;
                    this.$emit('selected-language-name', this.english);
                    this.$parent.$emit('selected-language', '2'); // TODO
                } else {
                    this.allLanguages = true;
                    this.localeLanguage = false;
                    this.englishLanguage = false;
                    this.$emit('selected-language-name', this.all);
                    this.$parent.$emit('selected-language', '0'); // TODO
                }
            },
        },
        mounted() {
            if (this.language === '2') {
                this.englishLanguage = true;
            } else if (['1', '3', '4'].includes(this.language)) {
                this.localeLanguage = true;
            } else {
                this.allLanguages = true;
            }
        },
        setup() {
            const getters = {
                ...useGetters('search', [
                    'language',
                ]),
            };

            return {
                ...getters,
            };
        },
    };
</script>
